import { FC } from 'react'
import { RouterProvider } from 'react-router-dom'

import { router } from './core/routes'
import { Root } from './providers/Root'

export const App: FC = () => {
  return (
    <Root>
      <RouterProvider router={router} />
    </Root>
  )
}
